module.exports = __webpack_public_path__ + "img/img-widget-send-feedback.ec2d5405.svg";